export default __webpack_public_path__ + "static/media/i151vp.6f9c75c0.webp";